import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import profileImage from "../../assests/defaultProfileImage.png"
import { logout } from "../../redux/auth/authAction";
import { toast } from "react-toastify";
import {
  FaUserCog,
  FaSignOutAlt
} from "react-icons/fa";
import { useSocket } from "../../hooks/useSocket";


const Dropnav = ({ onClose }) => {
  const dispatch = useDispatch()
  const { socket } = useSocket();
  const { loggingOut } = useSelector(state => state.auth)
  const { profilePhotoUrl, userData } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const handleTermsClick = () => {
    navigate("/terms");
    onClose();
  };

  const handlePrivacyClick = () => {
    navigate("/privacy-policy");
    onClose();
  };

  const navImage = profilePhotoUrl || profileImage;
  const fullName = userData ? `${userData.firstName} ${userData.lastName}` : "";

  const handleNavigate = (path) => {
    navigate(path);
    onClose();
  };


  const handleLogout = async () => {
    try {
      const isSuccessfulLoggout = await dispatch(logout(socket.id)).unwrap()

      if (isSuccessfulLoggout) {
        dispatch({ type: 'RESET_STORE' })
      }
    } catch (error) {
      toast.error(error.message)
    }
  }


  return (
    <>
      <div className="b1">
        <div className=" bg-customGray divide-gray-100 rounded-md shadow-black/35 ring-1 ring-black ring-opacity-5 focus:outline-none shadow-lg animate-fade-in">
          <div className="flex">
            <div className="ml-6 h-24 w-22 text-white hidden xl:flex">
              <div className="absolute w-56 h-22 bg-black justify-center p-1 mt-3 rounded-lg ">
                <div className="flex mx-2 items-center">
                  <img
                    src={navImage}
                    alt="Profile"
                    className="w-9 rounded-full"
                  />
                  <h1 className="mx-4">{fullName}</h1>
                </div>
                <div className="border-b mt-2"></div>
                <Link to="/profile">
                  <h2 className="text-center hover:opacity-80 dark:hover:bg-dark-third text-sm mt-1"
                    onClick={() => handleNavigate("/profile")}
                  > View Profile </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="py-1" role="none">
            <button
              onClick={() => handleNavigate("/setting")}
              className="text-white hover:opacity-80 hover:scale-105 transition duration-100 gap-6 flex px-3 py-3 text-sm"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-0"
            >
              <FaUserCog className="text-lg" />
              Settings & Privacy
            </button>
          </div>

          <div className="mt-1 border-y-[1px] border-white" role="none">
            <button
              onClick={handleLogout}
              className="text-white hover:opacity-80 hover:scale-105 transition w-full duration-100 flex justify-between px-3 py-3 text-sm"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-0"
            >
              <div className="flex items-center gap-6">
                <FaSignOutAlt className="text-lg" />
                Log Out
              </div>
              {loggingOut && <div className="w-6 h-6 border-4 border-customGray border-l-white border-t-white rounded-full animate-spin" />}
            </button>
          </div>
          <h1 className="text-center py-7 text-white text-xs">
            BlackDefynition <br />
            About Contact Us{" "}
            <button
              onClick={handleTermsClick}
              className="text-customGold hover:underline transition duration-200"
            >
              Terms and Conditions
            </button>{" "}
            ·{" "}
            <button
              onClick={handlePrivacyClick}
              className="text-customGold hover:underline transition duration-200"
            >
              Privacy Policy
            </button>
          </h1>
        </div>
      </div>
    </>
  );
};

export default Dropnav;
